import {
  ProcurementRequestsService,
  type UpdateProcurementRequestDTO,
} from "../../../api/procurementRequests"
import { useCreateWarehouseDocumentDraft } from "../shared/useCreateWarehouseDocumentDraft"

type PrefillItem = {
  product_id: string
  requested_qty?: number | string
  comment?: string
}

export function useCreateZAP() {
  const { createDocument, isCreating, isResolvingWarehouses, canCreate } =
    useCreateWarehouseDocumentDraft<
      { warehouse_id: string },
      { id: string },
      {
        preferredWarehouseId?: string
        replace?: boolean
        items?: PrefillItem[]
      }
    >({
      mutationKey: ["wms", "procurement-requests"] as const,
      documentCode: "ZAP",
      blockedWarehouseDescription:
        "Magazyn z kontekstu jest obecnie zablokowany przez aktywną inwentaryzację.",
      missingWarehouseDescription:
        "Brak aktywnego magazynu dostępnego do utworzenia dokumentu ZAP.",
      createDraftRequest: async (payload: any) => {
        if (payload.__preparedDraft) {
          return payload.__preparedDraft
        }
        const draft = await ProcurementRequestsService.initDraft({
          warehouse_id: payload.warehouse_id,
        })

        return draft
      },
      buildPayload: async (warehouseId, options) => {
        if (options?.items?.length) {
          const payload: UpdateProcurementRequestDTO = {
            items: options.items.map((item) => ({
              product_id: item.product_id,
              requested_qty: Number(item.requested_qty ?? 1),
              comment: item.comment?.trim() || undefined,
            })),
          }
          const draft = await ProcurementRequestsService.initDraft({
            warehouse_id: warehouseId,
          })
          await ProcurementRequestsService.updateByID(draft.id, payload)
          return { warehouse_id: warehouseId, __preparedDraft: draft } as any
        }
        return { warehouse_id: warehouseId }
      },
      getSuccessNavigation: (draft, options) => ({
        to: "/WMS/documents/zap/$zap",
        params: { zap: draft.id },
        search: { tab: "general", edit: 1 },
        replace: Boolean(options?.replace),
      }),
    })

  return {
    createZAP: (preferredWarehouseId?: string, items?: PrefillItem[]) =>
      createDocument({ preferredWarehouseId, items }),
    isCreating,
    isResolvingWarehouses,
    canCreate,
  }
}
